import styled from 'styled-components';

import { useI18n } from '../../hooks';
import VisuallyHiddenText from '../VisuallyHiddenText/VisuallyHiddenText';

const StyledNoValue = styled.span`
  display: inline-block;
  position: relative;
`;

const NoValue = () => {
  const t = useI18n();
  return (
    <StyledNoValue>
      <span aria-hidden>&ndash;&ndash;</span>
      <VisuallyHiddenText>{t('no_value')}</VisuallyHiddenText>
    </StyledNoValue>
  );
};

export default NoValue;
